/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DiscountCouponPaginateResponse } from '../../models/discount-coupon-paginate-response';

export interface GetDiscountCouponIndex$Params {

/**
 * Pagination offset
 */
  page?: number;

/**
 * Pagination limit
 */
  limit?: number;

/**
 * Pagination order field ascending
 */
  orderAsc?: 'id' | 'value' | 'reusable' | 'isUsed' | 'expire' | 'createdAt';

/**
 * Pagination order field descending
 */
  orderDesc?: 'id' | 'value' | 'reusable' | 'isUsed' | 'expire' | 'createdAt';

/**
 * Filter DiscountCoupon id
 */
  id?: number;

/**
 * Filter DiscountCampaign id
 */
  discountCampaign?: number;
}

export function getDiscountCouponIndex(http: HttpClient, rootUrl: string, params?: GetDiscountCouponIndex$Params, context?: HttpContext): Observable<StrictHttpResponse<DiscountCouponPaginateResponse>> {
  const rb = new RequestBuilder(rootUrl, getDiscountCouponIndex.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
    rb.query('orderAsc', params.orderAsc, {});
    rb.query('orderDesc', params.orderDesc, {});
    rb.query('id', params.id, {});
    rb.query('discountCampaign', params.discountCampaign, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DiscountCouponPaginateResponse>;
    })
  );
}

getDiscountCouponIndex.PATH = '/v1/discount-coupon';
